<template>
    <v-card class="orange lighten-4">
        <v-card-text>

            <span class="black--text">
                <b>Shipment: </b>
            </span>
            <span class="black--text">{{shipment.Reference}}</span><br>

            <span class="black--text">
                <b>Equipment: </b>
            </span>
            <span class="black--text">{{shipment.Equipment}}</span><br>

            <div v-for="pickup in shipment.Pickup"
                 :key="pickup.id">
                <span class="black--text">
                    <b>Pickup: </b>
                </span>
                <span class="black--text">{{pickup}}</span><br>
            </div>

            <span class="black--text">
                <b>Pickup Date: </b>
            </span>
            <span class="black--text">{{shipment.PickupDate}}</span><br>
            <div v-for="delivery in shipment.Delivery"
                 :key="delivery.id">
                <span class="black--text">
                    <b>Delivery: </b>
                </span>
                <span class="black--text">{{delivery}}</span><br>
            </div>
            <span class="black--text">
                <b>Delivery Date: </b>
            </span>
            <span class="black--text">{{shipment.DeliveryDate}}</span><br>

            <span class="black--text">
                <b>Miles: </b>
            </span>
            <span class="black--text">{{shipment.Miles}}</span><br>

            <div v-for="freight in shipment.Freight"
                 :key="freight.id">
                <span class="black--text">
                    <b>Freight: </b>
                </span>
                <span class="black--text">{{freight}}</span><br>
            </div>

            <div v-for="option in shipment.Options"
                 :key="option.id">
                <span class="black--text">
                    <b>Notes: </b>
                </span>
                <span class="black--text">{{option}}</span><br>
            </div>

            <span class="black--text">
                <b>Quote: </b>
                <span class="black--text">{{quotes.quote}}</span><br>
            </span>

            <span v-if="quotes.selected"
                  class="black--text">
                <b>Tender: </b>
                <span class="black--text">Yes</span><br>
            </span>

            <span v-if="!quotes.selected"
                  class="black--text">
                <b>Tender: </b>
                <span class="black--text">No</span><br>
            </span>

            <span v-if="!isBroker && brokerID"
                  class="black--text">
                <b>Broker: </b>
                <span class="black--text">
                    <broker-name :brokerID="brokerID"></broker-name>
                </span><br>
            </span>

            <v-divider></v-divider>

            <span class="black--text">
                <b>Shipping Instructions: </b><br>
            </span>
            <pre v-if="quotes.selected || !isBroker">
            <div style="white-space: pre-wrap"
                 class="black--text">{{shipment.Instructions}}
                 </div></pre><br>

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!isBroker"
                   icon
                   v-on:click="$emit('closeWaybill')">
                <v-icon>close</v-icon>
            </v-btn>
            <v-btn icon
                   v-on:click="$emit('printWaybill')">
                <v-icon>print</v-icon>
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import db from './fireBaseInit'
import brokerName from './BrokerName'

export default {
  name: 'waybill',
  data () {
    return {
      shipment: {},
      quotes: {}
    }
  },
  props: ['freightID', 'isBroker', 'brokerID'],
  components: { brokerName },
  mounted: function () {
    if (typeof this.brokerID !== 'undefined' && this.brokerID) {
      this.$bind('quotes', db.collection('conversations').doc(this.freightID).collection('brokers').doc(this.brokerID))
        .then((doc) => {
          // do nothing special
        })
        .catch((error) => {
          console.log('error in loading: ', error)
        })
    }
  },
  watch: {
    brokerID: function () {
      this.$bind('quotes', db.collection('conversations').doc(this.freightID).collection('brokers').doc(this.brokerID))
        .then((doc) => {
          return null
        })
        .catch((error) => {
          console.log('error in loading: ', error)
        })
    }
  },
  methods: {
  },
  firestore () {
    return {
      shipment: db.collection('freight').doc(this.freightID)
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/WayBill.vue